import React from "react";
//#region types
import { CommissionSalaryFormTypes } from "models/formTypes";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import { DashboardButtonGroup, FilterButton, PageLayouts, ReloadEvent } from "components/common";
import CommissionSalaryListContainer from "./listContainer";
import useCommissionSalaryReportFilterDefinition from "./forms/useReportFilterDefinition";
import { Grid } from "@mui/material";
import { useSalaryPermissions } from "components/salary";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const CommissionSalaryReport: React.FC = (props) => {
  const { filterFormFields: reportFilterDefinition, filterQueryStateHandler } =
    useCommissionSalaryReportFilterDefinition();

  const { isAnyCommissionSalaryAvailable } = useSalaryPermissions();

  return (
    <ReloadEvent
      render={(reloadKey, reload) => (
        <PageLayouts.DashboardLayout<CommissionSalaryFormTypes.Filter>
          entityKey={0}
          hasPermissions={isAnyCommissionSalaryAvailable}
          title={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.CommissionSalary.Commission)}
          topRightButtons={
            <DashboardButtonGroup
              buttons={[
                // <CreateCommissionButton reloadKey={reloadKey} reloadList={reload} />,
                // ACTION_SEPARATOR,
                <FilterButton />,
              ]}
            />
          }
          initialFilter={{
            yearAndMonth: new Date(),
          }}
          filterFields={reportFilterDefinition}
          filterQueryStateHandler={filterQueryStateHandler}
        >
          <Grid container item>
            <CommissionSalaryListContainer reloadKey={reloadKey} reloadList={reload} />
          </Grid>
        </PageLayouts.DashboardLayout>
      )}
    />
  );
};

export default CommissionSalaryReport;
